/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AfterContentInit, Component, ElementRef, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { UiBlockerHttpInterceptor } from '../ui-blocker-http-interceptor';
import { delay, startWith } from 'rxjs/operators';

//TODO rename to iriro-ui-blocker-overlay
@Component({
  selector: 'iric-ui-blocker-overlay-component, iriro-ui-blocker-overlay-component',
  templateUrl: './ui-blocker-overlay.component.html',
  styleUrls: ['./ui-blocker-overlay.component.scss'],
})
export class UiBlockerOverlayComponent implements OnInit, AfterContentInit {
  blockUi$: Observable<boolean> | undefined = undefined;

  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.getBlockUiState();
  }

  ngAfterContentInit(): void {
    this.el.nativeElement.focus();
  }

  private getBlockUiState() {
    this.blockUi$ = UiBlockerHttpInterceptor.blockUi.pipe(delay(0)).pipe(startWith(false));
  }
}
